import { IRecord } from "../../interfaces/interfaces";

export const adapterItemResponse = (response: any) => {
  let newResponse: IRecord = {
    _id: response.data._id,
    name: response.data.name,
    email: response.data.email,
    phone: response.data.phone,
    date: response.data.date,
  };

  return newResponse;
};
